<template>
    <div class="footer-navigation">
      <div class="back-step-btn"
           :class="{'v-hidden': prevHide}"
           :disabled="prevDisabled"
           @click="back">&lt; Back</div>

      <div class="next-step-btn"
           :class="{'v-hidden': nextHide}"
           :disabled="nextDisabled"
           @click="next">{{ nextBtnText }} &gt;</div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: "Navigation",

  props: {
    prevDisabled: Boolean,
    nextDisabled: Boolean,
    prevHide: Boolean,
    nextHide: Boolean,
    nextBtnText: {
      type: String,
      default: 'Next',
    },
  },

  computed: {
    ...mapGetters({
      currentView: 'navigation/getCurrentView',
    }),
  },

  methods: {
    next() {
      if (this.nextDisabled) return;

      if (this.$parent.submit === undefined) {
        // go to next view if there is no submit method in parent components
        this.$store.commit('navigation/nextView');
      } else {
        // otherwise run submit method on parent and continue to next view when it is resolved
        this.$parent.submit()
          .then(() => {
            this.$store.commit('navigation/nextView');
          });
      }
    },

    back() {
      if (!this.prevDisabled) {
        this.$store.commit('navigation/prevView');
      }
    },
  },
};
</script>
